import { getProvider as getSwapProvider } from "@/containers/swapToken/utils";

// Re-export the singleton provider from swapToken/utils to avoid duplication
export const getProvider = getSwapProvider;

// Export a singleton instance for backward compatibility
export const provider = getProvider();
